module.exports = __webpack_public_path__ + "img/icon-copy.2fc53d98.svg";